import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { Transformacion } from './components/Transformacion';
import { CarouselSection } from './components/CarouselSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { MidCTA } from './components/MidCTA';
import { TargetAudience } from './components/TargetAudience';
import { Comparison } from './components/Comparison';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1731716034156669';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-cream text-ink selection:bg-terracota/30 selection:text-terracota-dark font-sans" data-id="element-0" data-mp="ssss6tdacmci">
      <main data-id="element-1" data-mp="38b6kw4i7udz">
        <Hero data-id="element-2" data-mp="3ud1glcmeruc7" />
        <TestimonialsStrip data-id="element-3" data-mp="3udazyhcy738x" />
        <PainPoints data-id="element-4" data-mp="3ubzvsgflbtha" />
        <SolutionReveal data-id="element-5" data-mp="3uevs60bsia3m" />
        <Transformacion data-id="element-6" data-mp="d4o09u01u88q" />
        <CarouselSection data-id="element-7" data-mp="d4xpvgh6mddw" />
        <TomosSection data-id="element-8" data-mp="d45tw4joadn3" />
        <BonusSection data-id="element-9" data-mp="d2l6cyvrzuyq" />
        <MidCTA data-id="element-10" data-mp="85uk1ttdo34v" />
        <TargetAudience data-id="element-11" data-mp="85bap1hsmn2g" />
        <Comparison data-id="element-12" data-mp="864a1hefaaak" />
        <ExtendedTestimonials data-id="element-13" data-mp="83i2vivg1wsv" />
        <PricingSection data-id="element-14" data-mp="3gl4qfe4avuig" />
        <Guarantee data-id="element-15" data-mp="3gmfwjkl7xecq" />
        <FAQ data-id="element-16" data-mp="3glwb3twd07ty" />
        <FinalCTA data-id="element-17" data-mp="3gja5w0wxy4ew" />
      </main>
      <Footer data-id="element-18" data-mp="3bmjsxmgfnoxp" />
    </div>;
}